import './OtherProjects.scss'
import {otherProjects} from "../../config/data"
import Title from "../Title";
import Modal from "../Modal";
import {memo, useState} from "react";
import Animate from "../Animate";
import Icon from "../Icon/Icon";
import {FaAngleDown, FaAngleRight, FaAngleUp} from "react-icons/fa";
import Popper from "../Poper";
import {AiOutlineGithub} from "react-icons/ai";
import {BiLinkExternal} from "react-icons/bi";

const Portfolio = memo((props) => {
  const [openModal, setOpenModal] = useState(false)
  const [selectedProject, setSelectedProject] = useState({})

  const clickHandler = (event) => {
    setOpenModal(true)
    setSelectedProject(event.project)
  }

  return (
      <>
        <div id='otherProjects' className={'px-5'}>
          <Title title={'Other Projects'}/>

          <div className='pt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-10 items-center justify-center'>
            {otherProjects && otherProjects.map((otherProject, i) => (
                otherProject.projects && otherProject.projects.length ?
                    // <div onClick={() => {
                    //   setOpenModal(true)
                    // }} key={i} className='rounded-full'>
                    <ProjectGroup
                        project={otherProject}
                        index={i}
                        key={i}
                        total={otherProjects.length}
                        clickHandler={(event) => clickHandler(event)}
                    />
                    // </div>
                    :
                    <ProjectCard
                        project={otherProject}
                        index={i}
                        key={i}
                        total={otherProjects.length}
                    />
            ))}
          </div>

          <Modal open={openModal} onClose={() => setOpenModal(false)}>
            <h1 className='text-4xl mb-4'>{selectedProject.name}</h1>
            {selectedProject.description && <p className='mb-4'>{selectedProject.description}</p>}
            {selectedProject.gitHub && <p><span className='text-amber-600 dark:text-amber-400'>Github: </span>
              <a href={selectedProject.gitHub} target='_blank' className='text-sky-600' rel="noreferrer" style={{wordBreak: 'break-all'}}>
                {selectedProject.gitHub}
              </a>
            </p>}
            <div className='pt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-10 justify-center items-center'>
              {selectedProject?.projects && selectedProject?.projects.slice(0).reverse().map((otherProject, i) => (
                  <ProjectCard
                      project={otherProject}
                      index={i}
                      key={i}
                      total={selectedProject?.projects?.length}
                  />
              ))}
            </div>
          </Modal>
        </div>
      </>
  );
})

export default Portfolio;


const ProjectGroup = ({project, index, clickHandler}) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedProject] = useState(project)

  const toggle = () => {
    setShowModal(!showModal)
    clickHandler({
      showModal,
      project: selectedProject,
    })
  }

  return (
      <>
        <div className={`relative group h-full max-h-96 w-full max-w-[24rem] mx-auto aspect-square bg-gray-200 dark:bg-black rounded-full cursor-pointer border-2 border-white dark:border-black hover:!border-amber-400`}
             onClick={() => toggle()}
        >
          {project?.projects && project?.projects.slice(0).reverse().map((otherProject, i) => (
              <div
                  className={`absolute px-4 pt-6 duration-300 transform scale-90 ${otherProject.css}`}
                  key={index + i}
              >
                <ProjectCard
                    project={otherProject}
                    index={index + i}
                    key={index + i}
                    total={project?.projects?.length}
                />
              </div>
          ))}
          <div className="absolute py-4 px-6 left-0 bottom-0 w-full h-[50%] rounded-b-full shadow-lg bg-gray-50 dark:bg-nfr-color-800 duration-300 group-hover:shadow text-center">
            <h3 className='font-bold mb-2'>{project.name}</h3>
            <p className='leading-none mb-4'><small>{project.subtitle}</small></p>
            <div className='flex items-center justify-center'>
              {project.gitHub && <a href={project.gitHub} target='_blank' rel="noreferrer">
                <Popper title={'Github'}>
                  <AiOutlineGithub className={'text-4xl text-amber-500 hover:text-amber-400 duration-200'}/>
                </Popper>
              </a>}
            </div>
          </div>
        </div>
      </>
  )
}

const ProjectCard = ({project, index}) => {
  const [showFeatures, setShowFeatures] = useState(false)
  const toggleFeatures = () => {
    setShowFeatures(!showFeatures)
  }

  return (
      <>
        <Animate direction='up' duration={0.6} delay={0.1 * (showFeatures ? 0 : index)} distance={20} scrollTriggerStart='20% bottom'>
          <div className='otherProjectCard p-2 bg-nfr-color-000 dark:bg-nfr-color-700 rounded-xl shadow-lg shadow-gray-300 dark:shadow hover:shadow max-w-[24rem] m-auto duration-300 border-2 border-white dark:border-black hover:!border-amber-400'>
            {/*<div className='otherProjectCard p-2 bg-nfr-color-000 dark:bg-nfr-color-700 rounded-xl shadow hover:shadow-lg min-h-[294px] duration-500'>*/}
            {(!project.image && project.technologies.length) &&
                <div className='technology px-2 py-6 mb-2 rounded-2xl bg-nfr-color-100 dark:bg-nfr-color-900 flex gap-2'>
                  {project.technologies.map((tech, i) => (
                      <div key={i} className='w-1/3 flex items-center'>
                        <Icon name={tech}></Icon>
                        {i + 1 < project.technologies.length && <span className='text-3xl'> + </span>}
                      </div>
                  ))}
                </div>}
            {project.image &&
                <div className=''>
                  <img src={project.image} alt="" className='aspect-video w-full rounded-t-lg'/>
                </div>}
            <div className='flex flex-col'>
              <div className='pt-2 px-2 items-stretch'>
                <h5 className='text-black dark:text-white font-bold'>{project.name}</h5>
                {project.progress ? <div className='mt-2 mb-3'>Coming Soon ...</div> : <small>{project.subtitle}</small>}
              </div>
              <div className='px-2'>
                <hr className='my-2'/>
                <div>
                  {project.features && project.features.length &&
                      <div className='pb-6'>
                        <div className='flex justify-between'>
                          <div>Features:</div>
                          <button onClick={toggleFeatures}>{showFeatures ? <FaAngleUp/> : <FaAngleDown/>}</button>
                        </div>
                        {showFeatures &&
                            <ul>
                              {project.features && project.features.map((feature, i) => (
                                  <li key={i} className='flex items-center'><FaAngleRight className='mr-2'/> {feature}</li>
                              ))}
                            </ul>
                        }
                      </div>
                  }
                  {(project.image && project.technologies.length) &&
                      <div className='mb-2 flex gap-1'>
                        {project.technologies.map((tech, i) => (
                            <p key={i} className='text-xs font-bold'>{tech}
                              {i + 1 < project.technologies.length && <span> , </span>}
                            </p>
                        ))}
                      </div>}
                  <div className='mt-3 flex'>
                    {project.gitHub && <a href={project.gitHub} target='_blank' rel="noreferrer">
                      <Popper title={'Github'}>
                        <AiOutlineGithub className={'text-4xl text-amber-500 hover:text-amber-400 duration-200'}/>
                      </Popper>
                    </a>}
                    {project.link && <a href={project.link} target='_blank' rel="noreferrer">
                      <Popper title={'Link'}>
                        <BiLinkExternal className={'text-4xl text-amber-500 hover:text-amber-400 duration-200'}/>
                      </Popper>
                    </a>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Animate>
      </>
  )
}
